import { store as commonStore } from '@febos-io/common';
import { store as authStore } from '@febos-io/auth';
import { store as healthStore } from '@febos-io/health-common';

import appSagas from '../store/sagas';

export default [
  ...commonStore.sagas,
  ...authStore.sagas,
  ...healthStore.sagas,
  ...appSagas
];
